export default __webpack_public_path__ + "resources/icons/d322-6499.png";